import { components, MenuProps } from "react-select";

function AutosuggestMenu<T>(props: MenuProps<T, true>) {
  return (
    <components.Menu
      {...props}
      innerProps={{
        ...props.innerProps,
        onMouseLeave: props.selectProps.onMenuMouseLeave,
        onMouseEnter: props.selectProps.onMenuMouseEnter,
        onMouseOverCapture: props.selectProps.onMenuMouseEnter
      }}
    >
      {props.children}
    </components.Menu>
  );
}

export default AutosuggestMenu;
